import { Formik, useFormikContext  } from "formik";
import React, { useCallback, useEffect, useState } from "react";
import Select from "react-select";
import * as Yup from "yup";
import "react-phone-input-2/lib/style.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { toast } from "react-toastify";
import BackButton from "../../component/BackButton.jsx";
import Loader from "../../component/Loader.jsx";
import { getEmailTemplateDetailReducer, updateEmailTemplateReducer } from "../slice.js";

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { FetchEmailTemplateDetail, FetchEmailTemplateList } from "./EmailTemplateSlice";
import { wrapPlaceholders, unwrapPlaceholders } from "../../utils/placeholderUtils";





function EditTemplate() {
  const [ displaydata, setDisplaydata ] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [time, setTime] = useState(0);  
  //const details = useSelector((state) => state.emailTemplate.details);
  const list = useSelector((state) => state.emailTemplate.list);
  const details = useSelector((state) => state.emailTemplate.details);
  console.log("details:", details);
  const [submitting, setSubmitting] = useState(false);


  let companyOptions = [];
  const companiesStr = localStorage.getItem('companies');
  if (companiesStr) {
    try {
      const companies = JSON.parse(companiesStr);
      if (Array.isArray(companies) && companies.length > 0) {
        companyOptions = [
          { value: 0, label: 'All Companies' },
          ...companies.map(c => ({
            value: c.id,
            label: c.company_name
          }))
        ];
      }
    } catch (e) {
      // Optionally handle JSON parse error
      companyOptions = [];
    }
  }
  const [selectedCompany, setSelectedCompany] = useState(0);
  

  const getDetails = useCallback((id) => {
    dispatch(
      FetchEmailTemplateDetail({id})
    ).then(() => {
      setDisplaydata(true)
    });
  }, [dispatch]);

  const getList = useCallback(() => {
    dispatch(
      FetchEmailTemplateList({company_id:selectedCompany})
    ).then(() => {  
    });
  }, [dispatch,selectedCompany]);
  const initialValues = {
    id: details?.id || "",
    company_id: details?.company_id || "",
    name: details?.name 
    ? list.find(opt => opt.id === details?.id) // find the matching option object
    : null,
    subject:details?.subject || "",
    content:details?.content || "",
  };

  useEffect(() => {
      getList();
  }, [getList]);
  
  
  return (
    <article className="col-lg-9 articleClass">
      <div className="article-body store-bd-gy">
        <div className="row align-items-center col-rever">
          <BackButton />
          <div className="col-sm-12 col-md-12 col-lg-12 mb-3 text-center">
            <h3>Company Email Templates</h3>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-sm-12">
            <Formik
              initialValues={initialValues}
              validationSchema={Yup.object({
                subject: Yup.string().required("Required"),
                content: Yup.string().required("Required"),
              })}
              enableReinitialize
              onSubmit={async (values) => {
                setSubmitting(true);

                let payload = {
                  id: values?.id,
                  subject: values?.subject,
                  content: values?.content,
                };
                  
                dispatch(
                  updateEmailTemplateReducer(payload)
                ).then((res) => {
                  setSubmitting(false);

                  if (res?.payload?.code === 1) {
                    toast.success(res?.payload?.message);
                      navigate("/email-templates", { replace: true });
                  } else {
                    toast?.error(res?.payload?.message);
                  }
                });
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFormikState,
                setFieldValue,
                /* and other goodies */
              }) => (
                <form className="form-style" onSubmit={handleSubmit}>
                  <input type="hidden" name="id" value={values.id} />
                  <div className="row">
                  {Array.isArray(companyOptions) && companyOptions.length > 0 && (
                    <div className="col-sm-12 col-md-12 mb-4">
                        <label className="fw-bold">Company</label>
                        {errors.company_id && touched.company_id && (
                          <span className="text-red ms-1">{errors.company_id}</span>
                        )}
                        <div className="form-group">
                          <div className="input-container">
                          <Select
                              options={companyOptions}
                              isSearchable
                              placeholder="Select a company..."
                              defaultValue={companyOptions[selectedCompany]}
                              onChange={option => {
                                setDisplaydata(false)
                                setSelectedCompany(option.value);
                                getList()
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    )}

                  <div className="col-sm-12 col-md-12 mb-4">
                      <label className="fw-bold">Email Template Code</label>
                      {errors.name && touched.name && (
                        <span className="text-red ms-1">{errors.name}</span>
                      )}
                      <div className="form-group">
                        <div className="input-container">
                        <Select
                            name="name"
                            options={list}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}  // unique ID
                            value={values.name || null}            // full object
                            onChange={(val) => {
                              getDetails(val.id);      // pass id directly
                              setFieldValue("name", val); // store full object
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    {displaydata && (
                      <>
                        <div className="col-sm-12 col-md-12 mb-4">
                          <label className="fw-bold">Email Subject</label>
                          {errors.subject && touched.subject && (
                            <span className="text-red ms-1">{errors.subject}</span>
                          )}
                          <div className="form-group">
                            <div className="input-container">
                              <input
                                type="text"
                                className="form-control pl-5"
                                name="subject"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.subject}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-sm-12 col-md-12 mb-4">
                          <div className="form-group">
                            <label className="fw-bold">Email Content</label>
                            {errors.content && touched.content && (
                              <span className="text-red ms-1">
                                {errors.content}
                              </span>
                            )}
                            <div className="input-container">
                              <CKEditor
                                editor={ClassicEditor}
                                data={values.content}
                                onReady={editor => {
                                  // This runs when the editor is initialized
                                  editor.editing.view.change(writer => {
                                    writer.setStyle('min-height', '400px', editor.editing.view.document.getRoot());
                                  });
                                }}
                                onChange={(event, editor) => {
                                  const data = editor.getData();
                                  handleChange({
                                    target: {
                                      name: 'content',
                                      value: data
                                    }
                                  });
                                }}
                                onBlur={() => handleBlur({ target: { name: 'content' } })}
                              />
                            </div>
                          </div>
                        </div>


                        <div className="col-sm-6 col-md-6 text-center">
                          <button
                            type="submit"
                            className="btn btn-save"
                            disabled={submitting}
                          >
                            {submitting ? <Loader /> : "Done"}
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </article>
  );
}

export default EditTemplate;
